import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  wrapperContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1440px',
    padding: '0 16px',
  },
  heading: {
    maxWidth: '800px',
    fontSize: '28px',
    fontWeight: '500',
    marginBottom: '24px',
    textAlign: 'center',
  },
  textHighlight: {
    color: theme.palette.custom.primary,
  },
  actionsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)',
    gap: '32px',
    width: '100%',
    marginBottom: '32px',
    marginTop: '32px',
    [theme.breakpoints.up('mobile_l')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.up('tablet')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    [theme.breakpoints.up('laptop')]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
  },

  chatInput: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: '24px',
      paddingRight: '12px',
    },
  },
}))
